<template>
  <div class="card card-pad h-100">
    <div class="section-title">Ventas por Canal</div>
    <div style="margin-top:8px;">
      <highcharts :options="options" />
    </div>
    <div class="legend-grid">
      <div v-for="row in legend" :key="row.label" class="stat legend-item">
        <span class="dot" :style="{ backgroundColor: row.color }"></span>
        <span class="key">{{ row.label }}</span>
        <span class="val">{{ row.value }}€</span>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name:'DonutCard',
  props:{
    options:{ type:Object, required:true },
    legend:{ type:Array, default:()=>[] }
  }
}
</script>
<style>
  .legend-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }

  .legend-item .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
  }
</style>
